// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DateSelect_wrapper__2Ie8m","month":"DateSelect_month__1lAP9","day":"DateSelect_day__1s5jk","year":"DateSelect_year__qhTkH"};